import { put, takeLatest, select, all, takeEvery } from 'redux-saga/effects'

import * as contentTrashBinActions from '@tabeeb/modules/contentTrashBin/actions'
import * as contentTrashBinSelectors from '@tabeeb/modules/contentTrashBin/selectors'
import { isPdfPage } from '@tabeeb/services/pageService'
import * as gallerySelectors from '../selectors'
import { contentNotificationService } from '../../shared/content'
import * as rawActions from '../actions'

export function* addDeletedFolderToTrashbin(pageFolderId) {
  if (!pageFolderId) {
    return
  }

  const deletedFolders = yield select(contentTrashBinSelectors.getDeletedFolders)
  const deletedFolder = deletedFolders.find((folder) => folder.Id === pageFolderId)
  const galleryFolders = yield select(gallerySelectors.getFoldersList)

  if (pageFolderId && !deletedFolder) {
    const folder = galleryFolders.find((f) => f.Id === pageFolderId)

    if (folder) {
      yield put(contentTrashBinActions.addDeletedSessionFolder(folder))
    }
  }
}

export function* removePageFromGallery({ galleryList, page }) {
  yield put(rawActions.deleteGalleryItem({ pageId: page.id }))

  const pagesToDelete = isPdfPage(page.contentType)
    ? galleryList.filter((p) => p.contentUrl === page.contentUrl)
    : [page]

  yield put(contentTrashBinActions.addDeletedPages(pagesToDelete))
  return pagesToDelete
}

function* selectGalleryItem(action) {
  const { pageId } = action.payload
  const selectedFolderId = yield select(gallerySelectors.getSelectedFolderId)
  const selectedGalleryItemId = yield select(gallerySelectors.getSelectedGalleryItemId)

  const galleryList = yield select(gallerySelectors.getGalleryList)

  let rootGalleryList = galleryList.filter((item) => item.folderId === null)
  let folderGalleryList = galleryList.filter((item) => item.folderId === selectedFolderId)
  const deletedItem = galleryList.find((item) => item.id === pageId)
  if (!deletedItem) {
    return
  }

  const deletedPages = yield removePageFromGallery({ galleryList, page: deletedItem })
  if (deletedItem.folderId) {
    yield addDeletedFolderToTrashbin(deletedItem.folderId)
  }

  if (deletedPages.some((item) => item.id === selectedGalleryItemId)) {
    let selectIndex = folderGalleryList.findIndex((item) => item.id === pageId) - 1
    if (selectIndex < 0) {
      rootGalleryList = rootGalleryList.filter(
        (page) => page.id !== pageId && page.contentUrl !== deletedItem.contentUrl
      )
      folderGalleryList = folderGalleryList.filter(
        (page) => page.id !== pageId && page.contentUrl !== deletedItem.contentUrl
      )

      selectIndex = 0
    }

    if (folderGalleryList.length > selectIndex) {
      yield put(rawActions.onSelectGalleryItem({ pageId: folderGalleryList[selectIndex].id, updateWeb: true }))
    } else {
      yield put(rawActions.onSelectGalleryItem({ pageId: rootGalleryList[0].id, updateWeb: true }))
    }
  }
}

function* deleteEmit(action) {
  const { pageId } = action.payload
  yield contentNotificationService.notifyOfDeletePage({ pageId })
}

function* deleteItem() {
  yield all([
    takeEvery([rawActions.deleteGalleryItemSuccess, rawActions.onDeleteGalleryItem], selectGalleryItem),
    takeLatest(rawActions.deleteGalleryItemSuccess, deleteEmit),
  ])
}

export default deleteItem
